<template>
	<div id="app">
		<router-view></router-view> 
		
		 
		<div class="cus-float-menu-container" :class="!floatMenuShow?'cus-menu-hide':''">
			  
			  
			<span class="cus-float-menu" @click="navTo('/eshop/list')">VR逛店</span>
			<span class="cus-float-menu" @click="navTo('/businessCooperation')">招商加盟</span>
			<span class="cus-float-menu" @click="navTo('/company/companyInfo')">联系我们</span>
			
			
			<!-- 
			<span class="cus-float-menu" @click="changeFullScreen">全屏</span> 
			<router-link class="cus-float-menu" to="/businessCooperation">门店列表</router-link> 
			--> 
		</div>	
		
		
		<van-tabbar class="cus-van-tabbar" v-model="active_computed" active-color="rgba(184,134,11,1)" inactive-color="#FFFFFF" :placeholder="true" :fixed="true" @change="handleTabChange">
			<van-tabbar-item icon="home-o" replace to="/">品牌首页</van-tabbar-item>
			<van-tabbar-item icon="shop-collect-o" replace to="/goods/typeList">产品中心</van-tabbar-item>
			<van-tabbar-item icon="fire-o" replace to="/case/list">案例中心</van-tabbar-item>
			<van-tabbar-item icon="gift-card-o" replace to="/materialReplaceProject/list">产品替换</van-tabbar-item>
			<van-tabbar-item icon="manager-o" replace to="/my/myIndex" >个人中心</van-tabbar-item>
			
			<!-- 
			<van-tabbar-item icon="gift-card-o" replace to="/businessCooperation">招商加盟</van-tabbar-item> 
			-->
		</van-tabbar>
	</div>
</template>

<script> 
	
	export default {
		name: 'App',
		data() {
			return {
				active: 0,
				authToken:'',
				mainBody:'',
				floatMenuShow:true
			}
		},
		
		computed:{ 
			active_computed:{
				get(){
					return this.$store.state.activeTabIndex;
				},
				set(){}
			},
			
			currentMainBodyId(){
				return this.$store.state.mainBody.id;
			}
			
		},
		
		watch:{
			
		},
		
		created() { 
			 
		},
		mounted() { 
			 
			this.mainBody = JSON.parse(localStorage.getItem("MAINBODY"));
			if(this.mainBody){
				this.refreshMainBody(this.mainBody.authToken);
			}  
		}, 
		
		components: {},

		methods: {
			
			// 刷新mainBody信息
			refreshMainBody(_authToken){
				this.axios.get("/mainBody/initMainBody/"+ _authToken).then((res)=>{ 
					if(2000 == res.code){
						this.mainBody = res.content;   
						localStorage.setItem("MAINBODY", JSON.stringify(this.mainBody));     
						this.$store.commit('setMainBody',this.mainBody);
					}else{
						console.log(res.msg); 
					}  
				}).catch((err)=>{
					console.log(err);  
				}) 
			}, 
			
			showMenu(){
				this.floatMenuShow = true;
			},
			 
			 handleTabChange(_activeIndex){ 
				this.$store.commit('setActiveTabIndex',_activeIndex);
				  
				if(0==_activeIndex){
					this.floatMenuShow = true;
				}else{
					this.floatMenuShow = false;
				} 
				
			 },
			 
			 navTo(_url){ 
				this.$store.commit('setActiveTabIndex',-1);
				this.floatMenuShow = false;
				setTimeout(()=>{
					this.$router.push(_url);
				},500); 
			 },
			 
			 
			 changeFullScreen(){
			 	let element = document.documentElement;
			 	   if (this.fullScreenFlag) {
			 	    if (document.exitFullscreen) {
			 	     document.exitFullscreen();
			 	    } else if (document.webkitCancelFullScreen) {
			 	     document.webkitCancelFullScreen();
			 	    } else if (document.mozCancelFullScreen) {
			 	     document.mozCancelFullScreen();
			 	    } else if (document.msExitFullscreen) {
			 	     document.msExitFullscreen();
			 	    }
			 	   } else {
			 	    if (element.requestFullscreen) {
			 	     element.requestFullscreen();
			 	    } else if (element.webkitRequestFullScreen) {
			 	     element.webkitRequestFullScreen();
			 	    } else if (element.mozRequestFullScreen) {
			 	     element.mozRequestFullScreen();
			 	    } else if (element.msRequestFullscreen) {
			 	     // IE11
			 	     element.msRequestFullscreen();
			 	    }
			 	   }
			 	   this.fullScreenFlag = !this.fullScreenFlag;
			 }
		}
	}
</script>

<style lang="less">
	/****/
	@font-face {
		font-family:'AliPuHui';
		src: url('@/assets/fonts/Alibaba-PuHuiTi-Medium.ttf') format('truetype');
	}
	
	
	@font-face {
	  font-family: 'comm_icon_font';
	  src: url('@/assets/fonts/comm/iconfont.woff2?t=1641523396224') format('woff2'),
	       url('@/assets/fonts/comm/iconfont.woff?t=1641523396224') format('woff'),
	       url('@/assets/fonts/comm/iconfont.ttf?t=1641523396224') format('truetype');
	}
	
	.commicon {
	  font-family: 'comm_icon_font' !important;
	  font-size: 16px;
	  font-style: normal;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	}
	
	*{
		padding: 0px;
		margin: 0px;   
		box-sizing: border-box; 
	}
	body{ 
		 
	}
	@media screen and (min-width: 1000px){
		body{
			padding: 0px 25vw;
		}
	}
	
	/**
	 * font-family: 'AliPuHui', Avenir, Helvetica, Arial, sans-serif; 
	 */ 
	#app { 
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50; 
		position: relative;
		overflow: hidden;   
		box-sizing: border-box;   
	}
	
	.cus-float-menu-container{
		box-sizing: border-box;
		position: absolute; 
		right: 0vw;
		top: 10vh;
		display: flex;
		flex-direction: column; 
		padding: 5px;
		border-radius: 10px;
		transition: all 0.5s linear;
		overflow: hidden;
		width: 70px;
		height: auto;    
	}
	
	.cus-menu-hide{
		right: -15vw; 
		opacity: 0;  
		border-right-color: rgba(182,165,130,1);
	}
	
	.cus-float-menu{
		box-sizing: border-box;
		width: 60px;
		height: 60px; 
		border-radius: 50%;
		padding: 15px;
		margin-top: 10px;
		background-color: rgba(255, 255, 255, .7);
		color: rgba(0, 0, 0, .5);
		font-size: 12px;
		font-weight: bold;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: all 1s; 
		border: 1px solid rgba(0, 0, 0, .3);
	}
	
	
	.cus-float-menu:hover{
		background-color: rgba(182,165,130,1);
		color: #FFFFFF;
	}
	
	.cus-van-tabbar{
		box-sizing: border-box; 
		
	}
	
	.cus-g-container{
		box-sizing: border-box;
		width: 100%; 
		height: calc(100vh - 50px);  
	}
	  
	::-webkit-scrollbar {
		display: none;
	}
</style>
